export default {
    'main-bg-color': '#ffffff',

    primary: '#005CC3',
    'primary-hover': '#0053B0',
    'primary-40': '#003775',

    'primary-t40': 'rgba(0, 92, 195, 0.4)',
    'primary-t10': 'rgba(0, 92, 195, 0.1)',

    secondary: '#E30413',
    'secondary-hover': '#CC0411',
    'secondary-40': '#88020B',

    'secondary-t40': 'rgba(227, 4, 19, 0.4)',
    'secondary-t10': 'rgba(227, 4, 19, 0.1)',

    'surface-ground-1': '#F3F5F7',
    'surface-ground-2': '#E2E9ED',
    'surface-ground-3': '#D6E1E5',
    'surface-white': '#ffffff',
    'surface-dark-ground': '#020100',

    'surface-white-t5': 'rgba(255, 255, 255, 0.05)',
    'surface-white-t10': 'rgba(255, 255, 255, 0.1)',
    'surface-white-t25': 'rgba(255, 255, 255, 0.25)',
    'surface-white-t50': 'rgba(255, 255, 255, 0.5)',
    'surface-white-t75': 'rgba(255, 255, 255, 0.75)',

    'surface-black-t5': 'rgba(2, 1, 0, 0.05)',
    'surface-black-t10': 'rgba(2, 1, 0, 0.1)',
    'surface-black-t25': 'rgba(2, 1, 0, 0.25)',
    'surface-black-t50': 'rgba(2, 1, 0, 0.5)',
    'surface-black-t75': 'rgba(2, 1, 0, 0.75)',

    'body-text': '#020100',
    'subtle-text': 'rgba(2, 1, 0, 0.7)',
    'subtle-text2': 'rgba(2, 1, 0, 0.5)  ',
    'btn-text-white': '#ffffff',
    'btn-text-black': '#020100',
    'btn-text-gray': '#6D736B',

    green: '#0ABB86',
    'green-hover': '#067050',
    'green-40': '#09A879',

    'green-t40': 'rgba(10, 187, 134, 0.4)',
    'green-t10': 'rgba(10, 187, 134, 0.1)',

    // Viewport
    // --desktop-cummon': '1800px' // this resulotion is used for adaptations of laptops especially MacBooks
    // --desktop-default': '1440px'
    // --desktop-medium': '1280px'
    // --desktop-small': '1024px'
    // --tablet-default': '768px'
    // --mobile-default': '425px'

    'navigation-height': '46px',
    'header-height-default': '140px',
    'header-height-small': '80px',
    'mobile-bar-height': '72px',

    'primary-transition-time': '0s',
    'primary-transition-type': 'ease',
    'primary-transition': 'var(--primary-transition-time) var(--primary-transition-type)',

    'link-default-transition-time': '50ms',
    'link-default-transition-type': 'ease out',
    'link-default-transition': 'var(--link-default-transition-time) var(--link-default-transition-type)',

    'primary-scale-transition-time': '.1s',
    'primary-scale-transition-type': 'ease',
    'primary-scale-transition': 'var(--primary-scale-transition-time) var(--primary-scale-transition-type)',

    'secondary-transition-time': '.2s',
    'secondary-transition-type': 'ease',
    'secondary-transition': 'var(--secondary-transition-time) var(--secondary-transition-type)',

    'primary-active-state-scale': '.95',
    'secondary-active-state-scale': '.8',
    'increasing-active-state-scale': '1.1',

    'disabled-opacity': '0.5',
    'hover-opacity': '0.7',

    'window-shadow': 'rgb(0, 0, 0, 0.15)',

    'modal-z-index': '60'
};
